import { FC } from "react";

import { DesignToken, Link, Text } from "@livechat/design-system-react-components";

import { HelpCenter } from "constants/help-center";
import { withVar } from "themes/helpers";

import { trackLearnMoreClicked } from "./analytics";

export const Headline: FC = () => {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const trackLearnMore = () => {
    trackLearnMoreClicked();
  };

  return (
    <Text customColor={withVar(DesignToken.ContentBasicSecondary)}>
      Add one or more custom domains or a domain provided by HelpDesk and reply to tickets with your current email
      address. After confirming and adding the domain, you can use it in your reply address.{" "}
      <Link href={HelpCenter.DOMAINS} bold={false} target="_blank" onClick={trackLearnMore}>
        Learn more
      </Link>
    </Text>
  );
};
